export default "__VITE_ASSET__CMKkKztQ__"